"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const map_viewer_service_1 = require("../service/map-viewer.service");
const application_events_service_1 = require("../xs/services/events/application-events.service");
const BaseComponent_1 = require("./BaseComponent");
const Constants_1 = require("./Constants");
const Cesium = window.Cesium;
// the slider is used for image comparing (slide between two image layers)
class MapViewerComponent extends BaseComponent_1.BaseComponent {
    // the canvas is a native wrapper around us
    constructor(router, snackBar, dialog, applicationEvents, me, cesiumMap) {
        super(router, snackBar, dialog);
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.applicationEvents = applicationEvents;
        this.me = me;
        this.cesiumMap = cesiumMap;
        this.debug = Constants_1.Constants.debug_off;
        this.debugPrimary = Constants_1.Constants._orange;
        this.debugSecondary = Constants_1.Constants._white;
        this.canvas = null;
        this.uuid = this.__uuidv4();
        this.name = 'base';
        this.canvas = me.nativeElement;
        if (this.debug) {
            console.log('%c map-viewer-component %c CONSTRUCTOR ', this.debugPrimary, this.debugSecondary, me, this.canvas);
        }
    }
    ngOnChanges() { }
    init() {
        if (this.debug) {
            console.log('%c map-viewer-component %c init() ', this.debugPrimary, this.debugSecondary);
        }
        // pass in the canvas, and Cesium will inject itself into it
        this.cesiumMap.init(this.name, this.canvas);
    }
    destroy() {
        if (this.debug) {
            console.log('%c map-viewer-component %c destroy() ', this.debugPrimary, this.debugSecondary);
        }
        this.cesiumMap.destroy(this.name);
    }
    __uuidv4(token = '-', prefix = '') {
        return (prefix + 'xxxxxxxx' + token + 'xxxx' + token + '4xxx' + token + 'yxxx' + token + 'xxxxxxxxxxxx').replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
exports.MapViewerComponent = MapViewerComponent;
